import React, { useState, useEffect } from 'react';
import { Button, Col, Modal, Row, Card, Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';
import { useForm } from '../../hooks/useForm';
import classNames from 'classnames';

const ModEditCorte = ({ show, onClose, data, callBk }) => {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const { setResp } = useContextInfo();
    const [values, handleInputChange, reset, setFormValue] = useForm({ tipo: '', cargo: 0, plan: 0, instalacion: 0 });

    useEffect(() => {
        if (data && data.items) {
            try {
                setItems(JSON.parse(data.items));
            } catch (e) {
                console.error('Error parseando items', e);
                setItems([]);
            }
        }
    }, [data]);

    const onSubmit = async () => {
        setLoading(true);
        const body = {
            ...data,
            items: JSON.stringify(items), // Guardamos los cambios realizados
        };

        const res = await fetchConToken(`factura/cor`, body, 'PUT');
        setResp(res);
        setLoading(false);

        if (res.ok) {
            callBk();
            onClose();
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Editar Corte</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col>
                        {items.map((pt, i) => {
                            const typeLower = pt.type?.toLowerCase() || '';

                            // --- LÓGICA DE PERMISOS ---
                            const isInstalacion = typeLower.includes('instalación');
                            const isPlan = typeLower.includes('plan');
                            const isCargo = typeLower.includes('cargo'); // Aquí detecta "Cargo" o "cargo"
                            const isTicketPago = typeLower.includes('ticket registro de pago');

                            // Definimos si es editable (Instalación, Plan o Cargo)
                            const isEditable = isInstalacion || isPlan || isCargo;

                            return (
                                <Card key={i + 'napsy'} className="mb-3 border-light shadow-sm">
                                    <Card.Body>
                                        <Row className="align-items-center">
                                            <Col md={6}>
                                                <span className="fw-bold text-secondary">{pt.type}</span>
                                            </Col>

                                            {isPlan ? (
                                                <Row>
                                                    <Col>
                                                        <b className="mx-2 text-12"> Plan Actual</b>
                                                        <span className={classNames('badge bg-primary')}>
                                                            {' '}
                                                            {/* {pinfo.plan} */}
                                                        </span>
                                                    </Col>
                                                    <Col>
                                                        <OverlayTrigger
                                                            trigger="click"
                                                            placement="left"
                                                            overlay={
                                                                <Popover>
                                                                    <Popover.Header as="h3" className="text-center">
                                                                        Planes
                                                                       
                                                                    </Popover.Header>

                                                                    <Popover.Body>
                                                                        <div className="row row-cols-2">
                                                                            {/* {planes.map((us, i) => (
                                                                                <div key={i + 'bgol'}>
                                                                                    {!us.disabled && (
                                                                                        <div className="col">
                                                                                            {' '}
                                                                                            <button
                                                                                                key={us.id}
                                                                                                type="button"
                                                                                                style={{
                                                                                                    fontSize: '11px',
                                                                                                    width: '125px',
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    setPlan(us)
                                                                                                }
                                                                                                className={`btn mb-1 ${
                                                                                                    speed.id ===
                                                                                                        us.id &&
                                                                                                    'btn-success'
                                                                                                } ${
                                                                                                    pinfo?.id ===
                                                                                                        us.id &&
                                                                                                    'btn-info'
                                                                                                } border border-primary-subtlet rounded-lg text-9 px-2 py-1.5 text-center font-bold inline-flex items-center   m-0.5`}>
                                                                                                <i className="mdi mdi-wifi  text-primary  "></i>

                                                                                                {us.nombre || us.plan}
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ))} */}
                                                                        </div>
                                                                    </Popover.Body>
                                                                </Popover>
                                                            }
                                                            rootClose={false}>
                                                            <Button>Cambiar Plan</Button>
                                                        </OverlayTrigger>
                                                    </Col>
                                                </Row>
                                            ) : null}
                                            <Col md={6}>
                                                {/* SI ES TICKET: Bloqueado */}
                                                {isTicketPago ? (
                                                    <div className="p-2 bg-light rounded border">
                                                        <small className="text-danger fw-bold d-block">
                                                            <i className="bi bi-lock-fill me-1"></i>
                                                            No se puede editar esta opción
                                                        </small>
                                                        <span className="fs-5">${pt.monto}</span>
                                                    </div>
                                                ) : isEditable ? (
                                                    /* SI ES EDITABLE (Cargo, Plan, Instalación) */
                                                    <Form.Group>
                                                        <Form.Label className="small mb-1 text-primary">
                                                            {isCargo ? 'Monto del Cargo:' : 'Monto / Valor:'}
                                                        </Form.Label>
                                                        <Form.Control
                                                            type={isPlan ? 'text' : 'number'}
                                                            value={pt.monto}
                                                            onChange={(e) =>
                                                                handleInputChange(i, 'monto', e.target.value)
                                                            }
                                                            placeholder="Ingrese el nuevo valor"
                                                        />
                                                    </Form.Group>
                                                ) : (
                                                    /* CASO DEFAULT: Otros tipos */
                                                    <span className="badge bg-info fs-6">${pt.monto}</span>
                                                )}
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            );
                        })}

                        <div className="d-flex justify-content-end mt-4">
                            <Button variant="outline-secondary" className="me-2" onClick={onClose} disabled={loading}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={onSubmit} disabled={loading} className="px-4">
                                {loading ? 'Procesando...' : 'Guardar Cambios'}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default ModEditCorte;
